// lib/leasing/marketSignalDisplay.ts
// Pure presentation helpers shared by the MarketSignal renderers (MarketSignalRenderer row/card
// and MarketSignalPage). No React, no DOM.

import type { LeasingMarketSignalDTO } from '#types/types';

const SQFT_TO_SQM = 0.0929;

export const formatMarketSignalRent = (
  signal: LeasingMarketSignalDTO,
  locale: string,
  fallback = '-'
): string => {
  if (!signal.rentAmount || !signal.rentCurrency) return fallback;
  const cadence = signal.rentCadence?.toLowerCase() === 'annual' ? '/yr' : '/mo';
  return `${Intl.NumberFormat(locale, {
    style: 'currency',
    currency: signal.rentCurrency,
    maximumFractionDigits: 0,
  }).format(signal.rentAmount)}${cadence}`;
};

export const formatMarketSignalSurface = (
  signal: LeasingMarketSignalDTO,
  fallback = '-'
): string => {
  if (signal.areaSqm) return `${signal.areaSqm} m2`;
  if (signal.areaSqft) return `${Math.round(signal.areaSqft * SQFT_TO_SQM)} m2`;
  return fallback;
};
